<div
  *ngIf="isVisible()"
  class="ai-welcome"
  role="presentation"
  [style.animation-duration.ms]="displayDurationMs"
  (click)="dismiss()"
>
  <div class="ai-welcome-content">
    <app-ai-illustration class="ai-welcome-illustration" />
    <h2 class="ai-welcome-title">{{ 'page.artificialIntelligence.hero.title' | translate }}</h2>
  </div>
</div>
